"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useVideoJSMetrics = require("./useVideoJSMetrics");
Object.keys(_useVideoJSMetrics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoJSMetrics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoJSMetrics[key];
    }
  });
});